// extracted by mini-css-extract-plugin
export default {"header":"header_header__0BzvZ","container":"header_container__9eKBe","logo":"header_logo__cp+VC","featured":"header_featured__fHC2h"};